import React, { Component } from "react";

import { LTButton, LTText } from "@lambdatestincprivate/lt-components";

import NoResults from "../../../images/no-results";
import styles from "./index.module.css";

const Types = {
  BUILD_PAGE: "build page",
  COMMAND: "command",
  EXCEPTION: "exception",
  GENERIC: "generic",
  METADATA: "metadata",
  NO_DATA_AVAILABLE: "nodataavialable",
  PERFORMANCE: "performance",
  SELENIUM_LOGS: "selenium-logs",
  VISUAL: "visual",
  VISUAL_CAPABILITY: "visualCapability"
};

const Links = {
  SELENIUM:
    "https://www.lambdatest.com/support/docs/selenium-automation-capabilities/",
  CYPRESS: "https://www.lambdatest.com/support/docs/run-settings/"
};

class ComponentNoDataFound extends Component {
  render() {
    const {
      iconToRender = undefined,
      secondaryMessage = "",
      message = "No results found",
      hideHelpLink = true,
      buttonText = "",
      buttonLink = "",
      testType = "selenium",
      extraStyle = {},
      headerStyle = {}
    } = this.props;

    return (
      <div className={`${styles.message}`} style={extraStyle}>
        {iconToRender ? iconToRender : <NoResults />}
        <div className={styles.textContainer} data-testid="logs-not-available-msg">
          <LTText
            as={"h2"}
            variant={LTText.TextVariant.HEADER_BOLD}
            style={headerStyle}
          >
            {message}
          </LTText>
          {secondaryMessage && (
            <LTText as={"h4"} variant={LTText.TextVariant.SUBHEADER_REGULAR}>
              {secondaryMessage}
            </LTText>
          )}
          {!hideHelpLink && (
            <div className={styles.link}>
              <a data-testid="no-data-learn-more-link" href={Links[testType.toUpperCase()]} target="_blank">
                Learn More
              </a>
            </div>
          )}
        </div>
        {buttonText && (
          <LTButton
            data-testid="no-data-action-btn"
            variant={LTButton.Variant.PRIMARY}
            onClick={() => {
              window.open(buttonLink, "_self");
            }}
          >
            {buttonText}
          </LTButton>
        )}
      </div>
    );
  }
}

export default ComponentNoDataFound;
